import {
  Provider,
  QueryAndOutputs,
  WorkflowComponentCodeParams,
  WorkflowComponentParameterMode,
  WorkflowComponentParamType
} from '../types'

import { WorkflowComponent } from './common/workflowcomponent'

class McpToolOutput extends WorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.mcptooloutput',
        group: 'Input/Output',
        title: 'MCP Tool Output',
        description: `
          This component defines the output of the workflow when used as an MCP Tool by agents.
        `,
        starred: true
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'mode',
          type: WorkflowComponentParamType.Selection,
          mode: WorkflowComponentParameterMode.Radio,
          title: 'Output type',
          options: [
            {
              value: 'sync',
              name: 'Sync',
              description:
                'Outputs a JSON object with the data and the FQN of the result when the tool is invoked.',
              icon: 'sync'
            },
            {
              value: 'async',
              name: 'Async',
              description:
                'When invoked, creates a job and outputs a JSON object with job metadata, including the result table FQN. The result is available once the job is complete.',
              icon: 'async'
            }
          ],
          value: 'async',
          default: 'async',
          allowExpressions: false
        }
      ],
      []
    )
  }

  async getFullCodeSnippet({
    params
  }: WorkflowComponentCodeParams): Promise<QueryAndOutputs> {
    return {
      query: '',
      outputs: {}
    }
  }

  async getCode(_: WorkflowComponentCodeParams): Promise<QueryAndOutputs> {
    return {
      query: '',
      outputs: {}
    }
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.Snowflake]
  }
}

export { McpToolOutput }
